'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { Box } from '@s7/base';
import { useComponentDefaultProps } from '@s7/styles';
import { COMPONENT_ID, accordionDefaultProps } from './Accordion.contract.js';
import { AccordionProvider } from './context/AccordionProvider.js';
import { AccordionItem } from './AccordionItem/AccordionItem.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Accordion(props) {
    var _useComponentDefaultProps = useComponentDefaultProps(COMPONENT_ID.ACCORDION, accordionDefaultProps, props), id = _useComponentDefaultProps.id, loop = _useComponentDefaultProps.loop, children = _useComponentDefaultProps.children, multiple = _useComponentDefaultProps.multiple, value = _useComponentDefaultProps.value, defaultValue = _useComponentDefaultProps.defaultValue, onChange = _useComponentDefaultProps.onChange, transitionDuration = _useComponentDefaultProps.transitionDuration, disableChevronRotation = _useComponentDefaultProps.disableChevronRotation, chevronPosition = _useComponentDefaultProps.chevronPosition, chevronSize = _useComponentDefaultProps.chevronSize, chevron = _useComponentDefaultProps.chevron, classNames = _useComponentDefaultProps.classNames, styles = _useComponentDefaultProps.styles, variant = _useComponentDefaultProps.variant, labelProps = _useComponentDefaultProps.labelProps, theme = _useComponentDefaultProps.theme, others = _object_without_properties_loose(_useComponentDefaultProps, [
        "id",
        "loop",
        "children",
        "multiple",
        "value",
        "defaultValue",
        "onChange",
        "transitionDuration",
        "disableChevronRotation",
        "chevronPosition",
        "chevronSize",
        "chevron",
        "classNames",
        "styles",
        "variant",
        "labelProps",
        "theme"
    ]);
    return /*#__PURE__*/ jsx(AccordionProvider, {
        chevron: chevron,
        chevronPosition: chevronPosition,
        chevronSize: chevronSize,
        classNames: classNames,
        defaultValue: defaultValue,
        disableChevronRotation: disableChevronRotation,
        id: id,
        labelProps: labelProps,
        loop: loop,
        multiple: multiple,
        styles: styles,
        theme: theme,
        transitionDuration: transitionDuration,
        value: value,
        variant: variant,
        onChange: onChange,
        children: /*#__PURE__*/ jsx(Box, _extends({}, others, {
            "data-accordion": true,
            children: children
        }))
    });
}
Accordion.Item = AccordionItem;
Accordion.displayName = COMPONENT_ID.ACCORDION;

export { Accordion, Accordion as default };
